// import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

// @Directive({
//   selector: '[appDisableOnClick]'
// })
// export class DisableOnClickDirective {

//   private originalContent: string | null = null;

//   constructor(private el: ElementRef, private renderer: Renderer2) {}

//   @HostListener('click')
//   onClick() {
//     const button: HTMLButtonElement = this.el.nativeElement;
//      

//     // Save original button content
//     this.originalContent = button.innerHTML;

//     setTimeout(() => {
//       // Disable button
//       this.renderer.setProperty(button, 'disabled', true);

//       // Add loader spinner
//       this.renderer.setProperty(button, 'innerHTML',
//         `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...`
//       );

//       // Re-enable after 3 seconds
//       setTimeout(() => {
//         this.renderer.setProperty(button, 'disabled', false);

//         // Restore original content
//         if (this.originalContent) {
//           this.renderer.setProperty(button, 'innerHTML', this.originalContent);
//         }
//       }, 4000);
//     }, 50);
//   }
// }

import { Directive, ElementRef, HostBinding, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appDisableOnClick]'
})
export class DisableOnClickDirective {
  @Input('appDisableOnClick') holdMs = 3500; // use like [appDisableOnClick]="4000" if you want 4s

  // reflect the disabled state as an attribute (reliable for <button>)
  @HostBinding('attr.disabled') disabledAttr: '' | null = null;
  @HostBinding('class.is-loading') isLoading = false;

  private isLocked = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click', ['$event'])
  onClick(evt: MouseEvent) {
    if (this.isLocked) {
      // ignore if already disabled
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }

    this.isLocked = true;
    this.disabledAttr = '';                         // sets disabled attribute
    this.renderer.setProperty(this.el.nativeElement, 'disabled', true); // sets property too
    this.isLoading = true;

    setTimeout(() => {
      this.isLocked = false;
      this.disabledAttr = null;
      this.renderer.setProperty(this.el.nativeElement, 'disabled', false);
      this.isLoading = false;
    }, this.holdMs);
  }
}
